module.exports = __webpack_public_path__ + "images/for_company_page/gizmodo_62e37d6eff13308b3de966642354f603.png";